export default __webpack_public_path__ + "static/media/Location.2049aaed.svg";